import { Typography, capitalize } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, matchPath } from 'react-router-dom';

import { CustomButton } from '../../common';
import { Flex } from '../../common/Containers';
import { decodeUrl, formatUrl, makeLink } from '../../helpers';
import { useAppSelector } from '../../store';
import { getSchoolFromService } from '../../store/schoolSlice';
import { Links, links } from '../AdminConsole/AdminConsole.constants';
import { LinkPaths, RouteInfoContainer, TextContainer } from './RouteInfo.style';
import { RouteInfoDetails } from './RouteInfoDetails';

interface RouteInfoProps {
  smImage?: string;
  margin?: string;
  onClick?: any;
  banner?: string;
  description?: string;
  redirect?: () => void;
  image?: any;
  withButton?: boolean;
  buttonText?: string;
  lastRoute?: string;
  noLastRoute?: boolean;
}

export const RouteInfo: React.FC<RouteInfoProps> = ({
  smImage,
  margin,
  onClick,
  banner,
  description,
  redirect,
  image,
  withButton,
  buttonText,
  lastRoute,
  noLastRoute,
}) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const link = links.find((item: Links) => {
    return item?.link && item?.link.split('/')[1] === pathname.split('/')[1];
  });
  const paths = makeLink(formatUrl(pathname)).filter((path) => path.length);
  const { school } = useAppSelector((state) => state.school);

  useEffect(() => {
    dispatch(getSchoolFromService());
  }, []);

  return (
    <RouteInfoContainer margin={margin}>
      {link ? (
        <TextContainer onClick={redirect}>
          {pathname.length < 2 ? (
            <>
              <Typography variant="h5">Admin Console</Typography>
              <Typography variant="h4">|</Typography>
              <Typography variant="h5">{school?.name}</Typography>
            </>
          ) : (
            <RouteInfoDetails
              pageName={link?.banner || capitalize(decodeUrl(pathname))}
              description={!link?.noDesc ? link?.descriptionText : ''}
              smImage={smImage || link?.smImage}
              image={link?.image}
            />
          )}
        </TextContainer>
      ) : (
        <Flex gap="5px">
          <Typography variant="h5">School Console</Typography>
          <Typography variant="h4">|</Typography>
          <Typography variant="h5">{school?.name}</Typography>
        </Flex>
      )}

      <TextContainer right="flex-end">
        <LinkPaths variant="h6">
          <Link to="/">Pupil wallet / Admin Console</Link>
          {paths.map((path, index) => {
            if (noLastRoute && index >= paths.length - 1) {
              return null;
            }
            if (lastRoute && index >= paths.length - 1) {
              return (
                <Link to={``} key={index}>
                  {' '}
                  / {lastRoute}
                </Link>
              );
            }

            return (
              <Link to={``} key={index}>
                {' '}
                / {formatUrl(path)}
              </Link>
            );
          })}
        </LinkPaths>
        {withButton && link?.btnOption && pathname.length > 2 && (
          <CustomButton content={buttonText || link.btnOption} width="27%" onClick={onClick} />
        )}
      </TextContainer>
    </RouteInfoContainer>
  );
};
